import React, { Component, useEffect, useState, useRef } from "react";
import PageSizeOptions from "../../PageSizeOptions";
import Pagination from "../../../comman/pagination";
import { paginate, calculateIndex } from "../../../utlis/paginate";
import SendEmail from "./SendEmail";
import { getFormatedNumber } from "../../../services/appService";
import { useDispatch, useSelector } from "react-redux";
import {
  getFilterAllUsers,
  getRegisteredUsers,
  loadRegisteredUsers,
  loadRegisteredUsersByFilter,
  loadAllEmailHistory,
  getAllEmailHistory,
  getSentEmailStatus,
  getDeleteEmailStatus,
  SendEmailMessage,
  DeleteEmailMessage
} from "../../../app/store/users";
import { setCurrentPageTitle, setCurrentRoute } from "../../../app/store/layoutUI";
import MailHistory from "./MailHistory";
import { json, useParams } from "react-router-dom";
import AllCountries from "../../../services/allCountries";
import allCountryStates from "../../../services/allCountryStates";
import geoService from "../../../services/geoService";
import file from "file-saver";
import Moment from "react-moment";
import useDocDownload from "../../../app/hooks/useDocDownload";
import { getAlert, getConfirmAlert } from "../../../services/appAlerts";

const UsersEmail = (props) => {

  const { type, typeName } = props;

  const param = useParams();
  let msgType = param?.type;

  const route = [{ url: "", name: "Communications" }];

  const [candidates, setCandidates] = useState([]);
  const [selectedEmail, setSelectedEmail] = useState([]);
  const [selectedPerformers, setSelectedPerformers] = useState([]);
  const [userId, setUserId] = useState("");
  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [dataType, setDataType] = useState("");

  const [selectedObj, setSelectedObj] = useState(null);
  const [showHide, setShowHide] = useState(false);
  const [showHideMailHistory, setShowHideMailHistory] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(5);
  const [userType, setUserType] = useState(type);
  const [totalCount, setTotalCount] = useState(10);
  const [rowsCount, setRowsCount] = useState(0);
  const [viewType, setViewType] = useState(0);
  const [isFiltering, setIsFiltering] = useState(false);

  const [selectedKey, setSelectedKey] = useState("home");
  const [selectedPerformer, setSelectedPerformer] = useState(null);
  const [selectedPerformerId, setSelectedPerformerId] = useState(0);

  const registeredUsersSelector = useSelector(getRegisteredUsers);
  const filterAllUsersSelector = useSelector(getFilterAllUsers);
  const allEmailHistorySelector = useSelector(getAllEmailHistory);
  const sentEmailStatusSelector = useSelector(getSentEmailStatus);
  const deleteEmailStatusSelector = useSelector(getDeleteEmailStatus);

  const [handleDownloadFile] = useDocDownload();
  const [sendEmailShowHide, setSendEmailShowHide] = useState(false);
  const [selectedMailObj, setSelectedMailObj] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const isInitial = useRef(true);
  const isInitialFilter = useRef(true);

  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedPerformerId) {
      dispatch(loadAllEmailHistory(selectedPerformerId));
    }
  }, [selectedPerformerId]);

  useEffect(() => {
    if (sentEmailStatusSelector) {
      getAlert("", "Draft Mail Sent Successfully", "success");
      if (selectedPerformerId) dispatch(loadAllEmailHistory(selectedPerformerId));
      handleRefreshData();
    }
  }, [sentEmailStatusSelector]);

  useEffect(() => {
    if (deleteEmailStatusSelector) {
      getAlert("", "Draft Mail Deleted Successfully", "success");
      if (selectedPerformerId) dispatch(loadAllEmailHistory(selectedPerformerId));
      handleRefreshData();
    }
  }, [deleteEmailStatusSelector]);

  const handleResetSelection = () => {
    setSelectedPerformerId(0);
    setSelectedPerformer(null);
    setSelectedEmail([]);
    setSelectedPerformers([]);
  };

  const handleSelectPerformer = (item) => {
    const isSelected = selectedEmail.some(x => x.key === item.performerid);
    if (isSelected) {
      const newEmails = selectedEmail.filter(x => x.key !== item.performerid);
      setSelectedEmail(newEmails);
      
      const newPerformers = selectedPerformers.filter(x => x.performerid !== item.performerid);
      setSelectedPerformers(newPerformers);

      if (newEmails.length === 0) {
        setSelectedPerformerId(0);
        setSelectedPerformer(null);
      } else {
        const lastPerformer = newPerformers[newPerformers.length - 1];
        if (lastPerformer) {
          setSelectedPerformerId(lastPerformer.performerid);
          setSelectedPerformer(lastPerformer);
        }
      }
    } else {
      setSelectedEmail([...selectedEmail, { key: item.performerid, value: item.performeremail }]);
      setSelectedPerformers([...selectedPerformers, item]);
      setSelectedPerformerId(item.performerid);
      setSelectedPerformer(item);
    }
  };

  const getDisplayName = (performer) =>
    [performer?.performername, performer?.lastName].filter(Boolean).join(" ").trim() || "Unnamed User";

  const getInitials = (performer) => {
    const nameParts = getDisplayName(performer).split(" ").filter(Boolean);
    return nameParts.slice(0, 2).map((part) => part.charAt(0).toUpperCase()).join("");
  };

  const handleTabSelect = (key) => {
    setSelectedKey(key);
  };

  const handleSendEmail = async (item) => {
    const result = await getConfirmAlert("Draft Email", "Are you sure you want to Send this Draft mail?", "warning");
    if (result.isConfirmed)
      dispatch(SendEmailMessage(item.id));
  };

  const handleDeleteEmail = async (item) => {
    const result = await getConfirmAlert("Draft Email", "Are you sure you want to Delete this Draft mail?", "warning");
    if (result.isConfirmed)
      dispatch(DeleteEmailMessage(item.id));
  };

  const handleSendEmailShowHide = (item) => {
    setSendEmailShowHide(!sendEmailShowHide);
    setSelectedMailObj(item);
  };

  const handleUpdateModalShowHide = () => {
    setSendEmailShowHide(false);
    setSelectedMailObj(null);
    if (selectedPerformerId) {
      dispatch(loadAllEmailHistory(selectedPerformerId));
    }
    handleRefreshData();
  };

  useEffect(() => {
    dispatch(setCurrentPageTitle(typeName));
    dispatch(setCurrentRoute(route));
  }, [])

  useEffect(() => {
    setIsLoading(true);
    dispatch(loadRegisteredUsers(pageSize, currentPage, userType))
  }, []);

  useEffect(() => {
    const selectorList = registeredUsersSelector || [];
    if (isInitial.current && selectorList.length === 0) {
      isInitial.current = false;
      return;
    }
    isInitial.current = false;

    if (selectorList.length > 0) {
      setRowsCount(selectorList[0].totalApplicants);
      setCandidates(selectorList);
    } else {
      setCandidates([]);
      setRowsCount(0);
    }
    setIsLoading(false);
  }, [registeredUsersSelector]);

  useEffect(() => {
    const filterList = filterAllUsersSelector || [];
    if (isInitialFilter.current && filterList.length === 0) {
      isInitialFilter.current = false;
      return;
    }
    isInitialFilter.current = false;

    setPageSize(5);
    setCurrentPage(1);
    getPagedData(filterList, 1, 5);
    setIsLoading(false);
  }, [filterAllUsersSelector]);

  const getPagedData = (list, currentPage, pageSize) => {
    const items = paginate(list, currentPage, pageSize);
    if (items.length > 0)
      setRowsCount(items[0].totalApplicants);

    setCandidates(items);
  };

  const handlePageChange = (page) => {
    const { startIndex: start, endIndex: end } = calculateIndex(page, startIndex, endIndex);
    setCurrentPage(page);
    setStartIndex(start);
    setEndIndex(end);
    handleResetSelection();
    setIsLoading(true);
    if (dataType === "filter")
      handleFilter();
    else
      dispatch(loadRegisteredUsers(pageSize, page, userType))
  };

  const handlePageSizeChanged = ({ currentTarget }) => {
    setPageSize(currentTarget.value);
    setCurrentPage(1);
    setStartIndex(0);
    setEndIndex(5);
    handleResetSelection();
    setIsLoading(true);
    if (dataType === "filter")
      handleFilter();
    else
      dispatch(loadRegisteredUsers(currentTarget.value, currentPage, userType));
  };

  const handleModalShowHide = (obj, keepSelection = false) => {
    if (obj === "" || obj === "save" || obj === undefined) {
      setShowHide(false);
      setSelectedObj(null);
      setSelectedKey("home");
      if (obj === "save") {
        handleResetSelection();
        if (dataType === "filter")
          handleFilter();
        else
          dispatch(loadRegisteredUsers(pageSize, currentPage, userType));

        setSelectedEmail([]);
        setSelectedPerformers([]);
      }
    }
    else {
      if (!keepSelection) {
        setSelectedEmail([{ key: obj.performerid, value: obj.performeremail }]);
        setSelectedPerformers([obj]);
        setSelectedPerformer(obj);
        setSelectedPerformerId(obj.performerid);
      }
      setSelectedKey("compose");
    }
  };


  const handleShowHideMailHistory = (obj, type) => {
    setSelectedPerformer(obj);
    setSelectedPerformerId(obj.performerid);
    setSelectedKey(type === "draft" ? "draft" : "sent");
  };


  const handleFilter = async () => {
    setIsFiltering(true);
    setDataType("filter");
    handleResetSelection();
    setIsLoading(true);
    const frmBody = new FormData();
    frmBody.append("id", userId);
    frmBody.append("name", userName);
    frmBody.append("email", userEmail);
    frmBody.append("type", userType);
    dispatch(loadRegisteredUsersByFilter(frmBody));
    setTimeout(() => {
      setIsFiltering(false);
    }, 600);
  };

  const handleFilterCancel = async () => {
    setDataType("");
    setUserId("");
    setUserName("");
    setUserEmail("");
    setCurrentPage(1);
    setPageSize(5);
    handleResetSelection();
    setIsLoading(true);
    dispatch(loadRegisteredUsers(5, 1, userType));
    setIsFiltering(false);
  };

  const handleRefreshData = () => {
    if (dataType === "filter")
      getPagedData(filterAllUsersSelector, currentPage, pageSize);
    else
      dispatch(loadRegisteredUsers(pageSize, currentPage, userType));
  };

  const handleRefresh = () => {
    if (dataType === "filter") handleFilter();
    else {
      handleResetSelection();
      setIsLoading(true);
      dispatch(loadRegisteredUsers(pageSize, currentPage, userType));
    }
  };

  const handleSaveFile = (data, name) => {
    const blob = new Blob([data], { type: "text/plain;charset=utf-8" });
    file.saveAs(blob, name + ".json");
  };

  const loadAllCountryJs = async () => {
    console.log(AllCountries);
    const firstFiftyCountries = AllCountries.slice(200, 250);
    console.log(firstFiftyCountries);
    const countryStates = [];
    var result = await Promise.all(
      firstFiftyCountries.map(async (x) => {
        const st = await geoService.getGeoData(x.geonameId);
        //console.log(st);
        st.map(s => {
          const stObj = { ...s, countryGeonameId: x.geonameId };
          //console.log(stObj);
          countryStates.push(stObj);
        })
        //handleSaveFile(JSON.stringify(countryStates), x.countryName?.replace(/\s+/g, ''));
        //return countryStates;
        return x;
      })
    )

    console.log(result);
    console.log(countryStates);
    handleSaveFile(JSON.stringify(countryStates), "ctstates200_250");

  }


  return (
    <React.Fragment>
      <style>{`
        .wf-main-card,
        .wf-main-card input,
        .wf-main-card select,
        .wf-main-card button,
        .wf-main-card textarea,
        .wf-table-scroll th,
        .wf-table-scroll td {
          font-family: "Open Sans", "Segoe UI", Roboto, sans-serif !important;
        }

        @keyframes searchSlideDown {
          from {
            opacity: 0;
            transform: translateY(-8px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes shimmer {
          0%   { background-position: -600px 0; }
          100% { background-position: 600px 0; }
        }

        @keyframes loadingBar {
          0%   { width: 0%; opacity: 1; }
          70%  { width: 85%; opacity: 1; }
          100% { width: 100%; opacity: 0; }
        }

        .wf-loading-bar {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 3px;
          background: linear-gradient(90deg, #2563eb, #7c3aed, #2563eb);
          background-size: 200% 100%;
          animation: loadingBar 1.6s ease-in-out infinite;
          z-index: 10;
        }

        .skeleton-cell {
          display: block;
          height: 13px;
          border-radius: 6px;
          background: linear-gradient(
            90deg,
            #f1f5f9 25%,
            #e2e8f0 50%,
            #f1f5f9 75%
          );
          background-size: 600px 100%;
          animation: shimmer 1.4s ease-in-out infinite;
        }

        .skeleton-cell.sk-short  { width: 40%; }
        .skeleton-cell.sk-medium { width: 65%; }
        .skeleton-cell.sk-long   { width: 85%; }
        .skeleton-cell.sk-full   { width: 92%; }
        
        .wf-main-card {
          background: rgba(255, 255, 255, 0.97) !important;
          border: 1px solid rgba(226, 232, 240, 0.8) !important;
          box-shadow: 0 4px 24px -4px rgba(15, 23, 42, 0.06), 0 1px 4px -1px rgba(15, 23, 42, 0.04) !important;
          border-radius: 18px !important;
          transition: all 0.3s ease !important;
          overflow: hidden !important;
          position: relative !important;
          height: auto !important;
          min-height: 420px !important;
          display: flex !important;
          flex-direction: column !important;
          margin-bottom: 0 !important;
        }

        .wf-card-header-bar {
          position: relative !important;
          overflow: hidden !important;
          display: flex !important;
          align-items: center !important;
          justify-content: space-between !important;
          flex-wrap: wrap !important;
          gap: 12px !important;
          padding: 14px 20px !important;
          border-bottom: 1px solid #f1f5f9 !important;
          background: linear-gradient(90deg, #fafbfd 0%, #ffffff 100%) !important;
          border-radius: 18px 18px 0 0 !important;
          flex: 0 0 auto !important;
        }

        .wf-header-left {
          display: flex;
          align-items: center;
          gap: 14px;
          flex-wrap: wrap;
        }

        .wf-stats-chip {
          display: inline-flex !important;
          align-items: center !important;
          gap: 6px !important;
          background: rgba(100, 116, 139, 0.07) !important;
          border: 1px solid rgba(100, 116, 139, 0.18) !important;
          color: #475569 !important;
          border-radius: 999px !important;
          padding: 5px 12px !important;
          font-size: 12px !important;
          font-weight: 700 !important;
          letter-spacing: 0.2px !important;
        }

        .wf-stats-chip i {
          font-size: 11px !important;
        }

        .btn-search-trigger {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 8px !important;
          background: #ffffff !important;
          border: 1px solid #e2e8f0 !important;
          padding: 6px 14px !important;
          border-radius: 8px !important;
          font-size: 12.5px !important;
          font-weight: 600 !important;
          color: #475569 !important;
          cursor: pointer !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.02) !important;
          min-height: 38px !important;
        }

        .btn-search-trigger:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #cbd5e1 !important;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
        }

        .search-panel-collapse {
          background: linear-gradient(135deg, rgba(255,255,255,0.98) 0%, rgba(248,250,252,0.95) 100%) !important;
          backdrop-filter: blur(16px) !important;
          -webkit-backdrop-filter: blur(16px) !important;
          border: 1px solid rgba(203, 213, 225, 0.7) !important;
          border-radius: 16px !important;
          padding: 0 !important;
          box-shadow: 0 4px 24px -6px rgba(15, 23, 42, 0.08), 0 1px 4px -1px rgba(15, 23, 42, 0.04), inset 0 1px 0 rgba(255,255,255,0.9) !important;
          animation: searchSlideDown 0.3s cubic-bezier(0.16, 1, 0.3, 1) both;
          margin-top: 12px !important;
          margin-bottom: 8px !important;
          overflow: hidden !important;
        }

        .sp-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 14px 20px 12px;
          border-bottom: 1px solid rgba(226, 232, 240, 0.8);
          background: linear-gradient(90deg, #f8fafc 0%, #ffffff 100%);
        }

        .sp-header-title {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 13px;
          font-weight: 700;
          color: #1e293b;
          letter-spacing: 0.1px;
        }

        .sp-header-title i {
          color: #2563eb;
          font-size: 13px;
        }

        .sp-header-badge {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          background: rgba(37, 99, 235, 0.07);
          border: 1px solid rgba(37, 99, 235, 0.15);
          color: #1d4ed8;
          border-radius: 999px;
          padding: 3px 10px;
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 0.3px;
          text-transform: uppercase;
        }

        .sp-body {
          padding: 18px 20px 14px;
        }

        .sp-footer {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          gap: 8px;
          padding: 12px 20px;
          border-top: 1px solid rgba(226, 232, 240, 0.7);
          background: linear-gradient(90deg, #ffffff 0%, #f8fafc 100%);
        }

        .wf-control-label {
          font-size: 11px !important;
          font-weight: 700 !important;
          color: #64748b !important;
          text-transform: uppercase !important;
          letter-spacing: 0.7px !important;
          margin-bottom: 7px !important;
          display: flex !important;
          align-items: center !important;
          gap: 5px !important;
        }

        .wf-control-label i {
          color: #94a3b8;
          font-size: 11px;
        }

        .wf-input-wrap {
          position: relative;
        }

        .wf-input-icon {
          position: absolute;
          left: 12px;
          top: 50%;
          transform: translateY(-50%);
          color: #94a3b8;
          font-size: 13px;
          pointer-events: none;
          transition: color 0.2s ease;
          z-index: 1;
        }

        .wf-input-icon.wf-input-icon-top {
          top: 14px !important;
          transform: none !important;
        }

        .wf-input-wrap:focus-within .wf-input-icon {
          color: #2563eb;
        }

        .wf-input {
          border-radius: 10px !important;
          border: 1.5px solid #e2e8f0 !important;
          padding: 9px 14px 9px 36px !important;
          font-size: 13.5px !important;
          color: #1e293b !important;
          background: #ffffff !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          height: auto !important;
          width: 100% !important;
          box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.03) !important;
        }

        .wf-input::placeholder {
          color: #94a3b8 !important;
          font-weight: 400 !important;
        }

        .wf-input:hover {
          border-color: #94a3b8 !important;
          box-shadow: 0 2px 6px -1px rgba(0,0,0,0.06) !important;
        }

        .wf-input:focus {
          border-color: #2563eb !important;
          box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1), 0 2px 6px -1px rgba(37, 99, 235, 0.08) !important;
          outline: none !important;
          background: #fafbff !important;
        }

        .btn-action-search {
          display: inline-flex !important;
          align-items: center !important;
          gap: 8px !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          padding: 8px 16px !important;
          border-radius: 8px !important;
          font-size: 13px !important;
          font-weight: 600 !important;
          color: #475569 !important;
          cursor: pointer !important;
          transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
          outline: none !important;
        }

        .btn-action-search:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 4px 8px -1px rgba(15, 23, 42, 0.08) !important;
        }

        .btn-action-search i {
          transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1), color 0.2s ease !important;
        }

        .btn-action-search:disabled {
          background: #f1f5f9 !important;
          color: #94a3b8 !important;
          border-color: #cbd5e1 !important;
          cursor: not-allowed !important;
          transform: none !important;
          box-shadow: none !important;
          opacity: 0.75 !important;
        }

        .btn-action-search.btn-primary-search:disabled {
          background: #cbd5e1 !important;
          color: #94a3b8 !important;
          border-color: #cbd5e1 !important;
          cursor: not-allowed !important;
          transform: none !important;
          box-shadow: none !important;
          opacity: 0.85 !important;
        }


        .btn-action-search.btn-primary-search {
          background: #2563eb !important;
          color: #ffffff !important;
          border-color: #2563eb !important;
        }

        .btn-action-search.btn-primary-search:hover {
          background: #1d4ed8 !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 4px 10px -1px rgba(37, 99, 235, 0.25) !important;
        }

        .btn-action-search.btn-danger-search {
          background: rgba(239, 68, 68, 0.06) !important;
          color: #dc2626 !important;
          border: 1px solid rgba(239, 68, 68, 0.18) !important;
        }

        .btn-action-search.btn-danger-search:hover {
          background: rgba(239, 68, 68, 0.12) !important;
          color: #b91c1c !important;
          border-color: rgba(239, 68, 68, 0.28) !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 4px 8px -2px rgba(239, 68, 68, 0.12) !important;
        }

        .btn-action-search.btn-sent-action {
          background: rgba(13, 148, 136, 0.04) !important;
          color: #0d9488 !important;
          border: 1px solid rgba(13, 148, 136, 0.22) !important;
        }
        .btn-action-search.btn-sent-action:hover {
          background: rgba(13, 148, 136, 0.1) !important;
          color: #115e59 !important;
          border-color: rgba(13, 148, 136, 0.35) !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 4px 6px -1px rgba(13, 148, 136, 0.1) !important;
        }

        .btn-action-search.btn-draft-action {
          background: rgba(124, 58, 237, 0.04) !important;
          color: #7c3aed !important;
          border: 1px solid rgba(124, 58, 237, 0.22) !important;
        }
        .btn-action-search.btn-draft-action:hover {
          background: rgba(124, 58, 237, 0.1) !important;
          color: #6d28d9 !important;
          border-color: rgba(124, 58, 237, 0.35) !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 4px 6px -1px rgba(124, 58, 237, 0.1) !important;
        }

        /* Tabs styling */
        .wf-tab-bar {
          display: flex;
          align-items: stretch;
          gap: 4px;
          border-bottom: 2px solid #f1f5f9;
          margin-bottom: 0;
          padding: 8px 4px 0;
          position: relative;
          flex: 0 0 auto;
        }

        .wf-tab-btn {
          position: relative;
          display: inline-flex;
          align-items: center;
          gap: 7px;
          border: none;
          background: transparent;
          padding: 9px 16px 11px;
          font-size: 13.5px;
          font-weight: 600;
          color: #64748b;
          cursor: pointer;
          border-radius: 8px 8px 0 0;
          transition: color 0.2s ease, background 0.2s ease;
          outline: none;
          white-space: nowrap;
        }

        .wf-tab-btn i {
          font-size: 13px;
          transition: color 0.2s ease;
        }

        .wf-tab-btn:hover {
          color: #1e293b;
          background: rgba(37,99,235,0.04);
        }

        .wf-tab-btn:focus,
        .wf-tab-btn:focus-visible,
        .wf-tab-btn:active {
          outline: none !important;
          box-shadow: none !important;
          border-color: transparent !important;
        }

        .wf-tab-btn.active {
          color: #2563eb;
          font-weight: 700;
        }

        .wf-tab-btn.active i {
          color: #2563eb;
        }

        .wf-tab-btn::after {
          content: "";
          position: absolute;
          bottom: -2px;
          left: 0;
          right: 0;
          height: 2px;
          background: #2563eb;
          border-radius: 2px 2px 0 0;
          transform: scaleX(0);
          transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .wf-tab-btn.active::after {
          transform: scaleX(1);
        }

        .wf-tab-badge {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-width: 20px;
          height: 20px;
          padding: 0 6px;
          border-radius: 999px;
          font-size: 11px;
          font-weight: 700;
          background: #f1f5f9;
          color: #64748b;
          border: 1px solid #e2e8f0;
          transition: all 0.2s ease;
          line-height: 1;
        }

        .wf-tab-btn.active .wf-tab-badge {
          background: rgba(37,99,235,0.1);
          color: #1d4ed8;
          border-color: rgba(37,99,235,0.2);
        }

        .wf-tab-btn.tab-locked .wf-tab-badge {
          background: rgba(245,158,11,0.1);
          color: #b45309;
          border-color: rgba(245,158,11,0.2);
        }

        .wf-tab-panel {
          animation: tabFadeIn 0.28s cubic-bezier(0.16, 1, 0.3, 1) both;
          flex: 1 1 auto;
          min-height: auto;
          overflow-y: visible;
          overflow-x: hidden;
          padding-right: 4px;
        }

        @keyframes tabFadeIn {
          from { opacity: 0; transform: translateY(6px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        .wf-tabs-container {
          display: flex;
          flex: 1 1 auto !important;
          flex-direction: column;
          min-height: auto !important;
          overflow: visible !important;
        }

        /* Assign card / Selected User card */
        .wf-assign-card {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 20px;
          padding: 20px 24px;
          background: linear-gradient(135deg, rgba(37,99,235,0.04) 0%, rgba(124,58,237,0.03) 100%);
          border: 1px solid rgba(37,99,235,0.12);
          border-radius: 14px;
          margin: 16px 0;
          flex-wrap: wrap;
          animation: tabFadeIn 0.3s ease both;
        }

        .wf-assign-info {
          display: flex;
          align-items: center;
          gap: 14px;
        }

        .wf-assign-avatar {
          width: 44px;
          height: 44px;
          border-radius: 12px;
          background: linear-gradient(135deg, #2563eb, #7c3aed);
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 18px;
          flex-shrink: 0;
          font-weight: 700;
        }

        .wf-assign-meta strong {
          display: block;
          font-size: 14px;
          font-weight: 700;
          color: #1e293b;
          margin-bottom: 3px;
        }

        .wf-assign-meta span {
          font-size: 12px;
          color: #64748b;
          font-weight: 500;
        }

        .wf-assign-actions {
          display: flex;
          gap: 8px;
          align-items: center;
          flex-wrap: wrap;
        }

        .wf-assign-actions .btn-action-search {
          height: 38px !important;
          box-sizing: border-box !important;
          justify-content: center !important;
        }

        .wf-assign-actions .btn-danger-search {
          padding: 8px 12px !important;
          min-width: 38px !important;
        }

        /* Modern Table Style */
        .wf-table {
          width: 100% !important;
          border-collapse: separate !important;
          border-spacing: 0 2px !important;
        }

        .wf-table-scroll {
          overflow: auto !important;
          border-radius: 12px;
        }

        .wf-thead {
          background: linear-gradient(90deg, #f8fafc 0%, #f1f5f9 100%) !important;
          position: sticky !important;
          top: 0 !important;
          z-index: 2 !important;
        }

        .wf-thead th {
          font-size: 11.5px !important;
          font-weight: 700 !important;
          color: #475569 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.6px !important;
          padding: 13px 16px !important;
          border-bottom: 2px solid #e2e8f0 !important;
          border-top: none !important;
          white-space: nowrap !important;
        }

        .wf-table-row {
          cursor: pointer !important;
          transition: background 0.15s ease, box-shadow 0.15s ease, transform 0.1s ease !important;
        }

        .wf-table-row:hover {
          background: linear-gradient(90deg, rgba(37,99,235,0.04) 0%, rgba(37,99,235,0.015) 100%) !important;
          box-shadow: inset 3px 0 0 0 rgba(37,99,235,0.35) !important;
        }

        .wf-table-row.selected-row {
          background: linear-gradient(90deg, rgba(37,99,235,0.07) 0%, rgba(37,99,235,0.02) 100%) !important;
          box-shadow: inset 4px 0 0 0 #2563eb !important;
        }

        .wf-table-row.selected-row td {
          color: #1e3a8a !important;
          font-weight: 500 !important;
          border-bottom: 1px solid rgba(37,99,235,0.08) !important;
        }

        .wf-id-cell {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          min-width: 64px;
          padding: 4px 8px;
          border-radius: 999px;
          background: #f8fafc;
          border: 1px solid #e2e8f0;
          font-size: 12px;
          font-weight: 700;
          color: #64748b;
        }

        .wf-id-cell.is-selected {
          background: rgba(37,99,235,0.08);
          border-color: rgba(37,99,235,0.22);
          color: #2563eb;
        }

        .wf-table td {
          padding: 13px 16px !important;
          font-size: 13px !important;
          color: #000000 !important;
          border-bottom: 1px solid #f1f5f9 !important;
          vertical-align: middle !important;
        }

        /* Custom Checkbox Styles */
        .wf-checkbox-wrapper {
          display: inline-flex;
          align-items: center;
          cursor: pointer;
          user-select: none;
        }

        .wf-custom-checkbox {
          width: 18px;
          height: 18px;
          border-radius: 6px;
          border: 2px solid #cbd5e1;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s ease;
          background: #ffffff;
          flex-shrink: 0;
        }

        .wf-table-row:hover .wf-custom-checkbox {
          border-color: #94a3b8;
        }

        .wf-custom-checkbox.checked {
          background: #2563eb;
          border-color: #2563eb;
          color: #ffffff;
        }

        .wf-custom-checkbox.checked i {
          transform: scale(1);
          opacity: 1;
        }

        .wf-custom-checkbox i {
          font-size: 10px;
          color: #ffffff;
          transform: scale(0.7);
          opacity: 0;
          transition: all 0.15s cubic-bezier(0.12, 0.4, 0.29, 1.46);
        }

        /* Avatar styles */
        .wf-name-cell { display: flex; align-items: center; gap: 10px; min-width: 190px; }
        .wf-name-avatar {
          width: 34px;
          height: 34px;
          border-radius: 10px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, rgba(37,99,235,0.12), rgba(20,184,166,0.1));
          border: 1px solid rgba(37,99,235,0.16);
          color: #1d4ed8;
          font-size: 12px;
          font-weight: 800;
          flex-shrink: 0;
        }
        .wf-avatar-stack {
          display: flex;
          align-items: center;
        }
        .wf-name-avatar.stack-avatar {
          background: #e0e7ff !important;
          color: #4338ca !important;
          border: 2px solid #ffffff !important;
          box-shadow: 0 2px 8px -2px rgba(15, 23, 42, 0.15) !important;
          transition: transform 0.2s ease !important;
          flex-shrink: 0 !important;
        }
        .wf-name-avatar.stack-avatar:hover {
          transform: translateY(-2px) scale(1.05) !important;
          z-index: 15 !important;
          box-shadow: 0 4px 12px -2px rgba(15, 23, 42, 0.25) !important;
        }
        .wf-name-avatar.stack-avatar.stack-more {
          background: #f1f5f9 !important;
          color: #475569 !important;
          border: 2px solid #ffffff !important;
          font-size: 11px !important;
          font-weight: 700 !important;
        }
        .wf-name-meta { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
        .wf-name-main { font-weight: 700; color: #1e293b; }

        .wf-data-line {
          display: inline-flex;
          align-items: center;
          gap: 7px;
          color: #475569;
          font-size: 12.8px;
          white-space: nowrap;
        }
        .wf-data-line i {
          color: #94a3b8;
          font-size: 12px;
          transition: color 0.2s ease;
        }
        .wf-data-line i.fa-envelope-o, 
        .wf-assign-meta i.fa-envelope { color: #3b82f6 !important; }
        
        .wf-data-line i.fa-phone, 
        .wf-assign-meta i.fa-phone { color: #10b981 !important; }

        .wf-data-line i.fa-paper-plane { color: #0d9488 !important; }
        .wf-data-line i.fa-pencil-square-o { color: #7c3aed !important; }
        
        .wf-email-line {
          max-width: 250px;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .wf-empty-value {
          color: #cbd5e1;
          font-size: 12px;
          font-weight: 600;
        }

        .wf-empty-state {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 40px 24px;
          text-align: center;
          gap: 12px;
          animation: tabFadeIn 0.3s ease both;
        }

        .wf-empty-icon {
          width: 52px;
          height: 52px;
          border-radius: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 22px;
          background: linear-gradient(135deg, rgba(37,99,235,0.08) 0%, rgba(124,58,237,0.06) 100%);
          border: 1px solid rgba(37,99,235,0.12);
          color: #2563eb;
          margin-bottom: 4px;
        }

        .wf-empty-title {
          font-size: 15px;
          font-weight: 700;
          color: #1e293b;
          margin: 0;
          width: 100%;
        }

        .wf-empty-desc {
          font-size: 13px;
          color: #64748b;
          margin: 0 auto;
          line-height: 1.6;
          width: 100%;
        }

        /* Re-used awp styles for tab headers */
        .awp-card {
          border: 1px solid rgba(226,232,240,0.8);
          border-radius: 16px;
          background: #ffffff;
          box-shadow: 0 4px 24px -4px rgba(15,23,42,0.06);
          margin-top: 10px;
          overflow: hidden;
        }

        .awp-form-header {
          display: flex; align-items: center; gap: 14px;
          padding: 16px 22px;
          background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
          border-bottom: 1.5px solid #e2e8f0;
          position: relative; overflow: hidden;
        }
        .awp-form-header-icon {
          width: 42px; height: 42px; border-radius: 12px;
          background: rgba(37,99,235,0.06); border: 1.5px solid rgba(37,99,235,0.1);
          display: flex; align-items: center; justify-content: center;
          font-size: 17px; color: #2563eb; flex-shrink: 0;
        }
        .awp-form-header-title {
          color: #0f172a; font-size: 14.5px; font-weight: 800; margin: 0; line-height: 1.2;
        }
        .awp-form-header-sub {
          color: #64748b; font-size: 12px; margin-top: 3px; font-weight: 500; margin-bottom: 0;
        }
        .awp-form-header-badge {
          margin-left: auto;
          background: #f1f5f9; border: 1px solid #e2e8f0;
          border-radius: 999px; padding: 4px 12px;
          color: #475569; font-size: 11.5px; font-weight: 700;
          display: flex; align-items: center; gap: 6px;
        }
      `}</style>

      <div className="col-md-12">
        <div className="card mb-4 wf-main-card shadow-none">
          <div className="wf-card-header-bar">
            {isLoading && <div className="wf-loading-bar" />}
            <div className="wf-header-left">
              <PageSizeOptions
                pageSize={pageSize}
                onChange={handlePageSizeChanged}
              />
              <span className="wf-stats-chip">
                <i className="fa fa-users" aria-hidden="true" />
                {rowsCount} Total
              </span>
            </div>
            <div style={{ display: "flex", gap: "8px" }}>
              <button
                className="btn-search-trigger"
                data-toggle="collapse"
                data-target="#collapseExample"
              >
                <i className="fa fa-filter" aria-hidden="true" /> Filters
              </button>
              <button
                className="btn-search-trigger"
                onClick={handleRefresh}
                disabled={isLoading}
                title={`Reload ${typeName}`}
              >
                <i className="fa fa-refresh" aria-hidden="true" /> Refresh
              </button>
            </div>
          </div>

          <div className="px-3">
            <div className="collapse" id="collapseExample">
              <div className="search-panel-collapse">

                {/* Panel Header */}
                <div className="sp-header">
                  <span className="sp-header-title">
                    <i className="fa fa-sliders" />
                    Filter {typeName} Registry
                  </span>
                  <span className="sp-header-badge">
                    <i className="fa fa-filter" /> {dataType === "filter" ? "Filter Active" : "Advanced Filters"}
                  </span>
                </div>

                {/* Filter Fields */}
                <div className="sp-body">
                  <div className="row">

                    {/* User ID */}
                    <div className="col-md-2 form-group mb-3">
                      <label htmlFor="userId" className="wf-control-label">
                        <i className="fa fa-hashtag" /> ID
                      </label>
                      <div className="wf-input-wrap">
                        <i className="fa fa-hashtag wf-input-icon" aria-hidden="true" />
                        <input
                          type="text"
                          name="userId"
                          id="userId"
                          className="form-control wf-input"
                          placeholder="e.g. 1042"
                          value={userId}
                          onChange={({ currentTarget }) => setUserId(currentTarget.value)}
                          onKeyDown={e => e.key === "Enter" && handleFilter()}
                          autoComplete="off"
                        />
                      </div>
                    </div>

                    {/* User Name */}
                    <div className="col-md-5 form-group mb-3">
                      <label htmlFor="userName" className="wf-control-label">
                        <i className="fa fa-user" /> Name
                      </label>
                      <div className="wf-input-wrap">
                        <i className="fa fa-search wf-input-icon" aria-hidden="true" />
                        <input
                          type="text"
                          name="userName"
                          id="userName"
                          className="form-control wf-input"
                          placeholder="Search name…"
                          value={userName}
                          onChange={({ currentTarget }) => setUserName(currentTarget.value)}
                          onKeyDown={e => e.key === "Enter" && handleFilter()}
                          autoComplete="off"
                        />
                      </div>
                    </div>

                    {/* User Email */}
                    <div className="col-md-5 form-group mb-3">
                      <label htmlFor="userEmail" className="wf-control-label">
                        <i className="fa fa-envelope" /> Email
                      </label>
                      <div className="wf-input-wrap">
                        <i className="fa fa-envelope wf-input-icon" aria-hidden="true" />
                        <input
                          type="text"
                          name="userEmail"
                          id="userEmail"
                          className="form-control wf-input"
                          placeholder="Search email…"
                          value={userEmail}
                          onChange={({ currentTarget }) => setUserEmail(currentTarget.value)}
                          onKeyDown={e => e.key === "Enter" && handleFilter()}
                          autoComplete="off"
                        />
                      </div>
                    </div>

                  </div>
                </div>

                {/* Action Footer */}
                <div className="sp-footer">
                  <button
                    className="btn-action-search btn-danger-search"
                    data-toggle="collapse"
                    data-target="#collapseExample"
                    onClick={handleFilterCancel}
                  >
                    <i className="fa fa-times" aria-hidden="true" /> Clear &amp; Close
                  </button>
                  <button
                    className="btn-action-search"
                    onClick={handleFilterCancel}
                  >
                    <i className="fa fa-refresh" aria-hidden="true" /> Reset
                  </button>
                  <button
                    className="btn-action-search btn-primary-search"
                    onClick={() => handleFilter()}
                    disabled={isFiltering || (!userId.trim() && !userName.trim() && !userEmail.trim())}
                  >
                    {isFiltering ? (
                      <>
                        <i className="fa fa-circle-o-notch fa-spin" aria-hidden="true" /> Applying...
                      </>
                    ) : (
                      <>
                        <i className="fa fa-search" aria-hidden="true" /> Apply Filters
                      </>
                    )}
                  </button>
                </div>

              </div>
            </div>
          </div>

          <div className="card-body px-3 pt-0 pb-3 wf-tabs-container">
            {/* Custom Tab Bar */}
            <div className="wf-tab-bar">
              <button
                className={`wf-tab-btn${selectedKey === "home" ? " active" : ""}`}
                onClick={() => handleTabSelect("home")}
              >
                <i className="fa fa-list-alt" />
                {typeName} Registry
                <span className="wf-tab-badge">{candidates.length > 0 ? rowsCount : "—"}</span>
              </button>
              <button
                className={`wf-tab-btn${selectedKey === "compose" ? " active" : ""}${selectedPerformerId === 0 ? " tab-locked" : ""}`}
                onClick={() => handleTabSelect("compose")}
              >
                <i className="fa fa-envelope" />
                Compose Message
                {selectedPerformerId === 0 ? (
                  <span className="wf-tab-badge"><i className="fa fa-lock" style={{ fontSize: 9 }} /></span>
                ) : (
                  selectedEmail.length > 0 && (
                    <span className="wf-tab-badge">{selectedEmail.length}</span>
                  )
                )}
              </button>
              <button
                className={`wf-tab-btn${selectedKey === "sent" ? " active" : ""}${selectedPerformerId === 0 ? " tab-locked" : ""}`}
                onClick={() => handleTabSelect("sent")}
              >
                <i className="fa fa-paper-plane" />
                Sent History
                {selectedPerformerId === 0 ? (
                  <span className="wf-tab-badge"><i className="fa fa-lock" style={{ fontSize: 9 }} /></span>
                ) : (
                  <span className="wf-tab-badge">
                    {selectedPerformer?.allMail || 0}
                  </span>
                )}
              </button>
              <button
                className={`wf-tab-btn${selectedKey === "draft" ? " active" : ""}${selectedPerformerId === 0 ? " tab-locked" : ""}`}
                onClick={() => handleTabSelect("draft")}
              >
                <i className="fa fa-pencil-square-o" />
                Draft Messages
                {selectedPerformerId === 0 ? (
                  <span className="wf-tab-badge"><i className="fa fa-lock" style={{ fontSize: 9 }} /></span>
                ) : (
                  <span className="wf-tab-badge">
                    {selectedPerformer?.draftMail || 0}
                  </span>
                )}
              </button>
            </div>

            {/* Tab Panels */}
            {selectedKey === "home" && (
              <div className="wf-tab-panel">
                {/* Selected user context card */}
                {selectedPerformerId > 0 && selectedPerformer && (
                  <div className="wf-assign-card" style={{ marginTop: 8, marginBottom: 14 }}>
                    <div className="wf-assign-info">
                      {selectedPerformers.length > 1 ? (
                        <div className="wf-avatar-stack">
                          {selectedPerformers.slice(0, 3).map((perf, idx) => (
                            <span
                              key={perf.performerid}
                              className="wf-name-avatar stack-avatar"
                              style={{
                                zIndex: 10 - idx,
                                marginLeft: idx > 0 ? "-12px" : "0"
                              }}
                              title={`${perf.performername} ${perf.lastName}`}
                            >
                              {getInitials(perf)}
                            </span>
                          ))}
                          {selectedPerformers.length > 3 && (
                            <span
                              className="wf-name-avatar stack-avatar stack-more"
                              style={{
                                zIndex: 5,
                                marginLeft: "-12px"
                              }}
                            >
                              +{selectedPerformers.length - 3}
                            </span>
                          )}
                        </div>
                      ) : (
                        <div className="wf-assign-avatar">
                          {getInitials(selectedPerformer)}
                        </div>
                      )}
                      <div className="wf-assign-meta">
                        {selectedPerformers.length > 1 ? (
                          <>
                            <strong>{selectedPerformers.length} Recipients Selected</strong>
                            <span>
                              Active Performer: {selectedPerformer.performername} {selectedPerformer.lastName} ({selectedPerformer.performeremail})
                            </span>
                          </>
                        ) : (
                          <>
                            <strong>
                              {selectedPerformer.performername} {selectedPerformer.lastName}
                            </strong>
                            <span>
                              <i className="fa fa-envelope" style={{ marginRight: 4 }} />
                              {selectedPerformer.performeremail}
                              &nbsp;&bull;&nbsp;
                              <i className="fa fa-phone" style={{ marginRight: 4 }} />
                              {selectedPerformer.contactNo ? getFormatedNumber(selectedPerformer.contactNo) : "No Contact"}
                            </span>
                          </>
                        )}
                      </div>
                    </div>
                    <div className="wf-assign-actions">
                      {selectedPerformers.length <= 1 && (
                        <>
                          <button
                            className="btn-action-search"
                            onClick={() => handleTabSelect("sent")}
                          >
                            <i className="fa fa-paper-plane" /> Sent ({selectedPerformer.allMail || 0})
                          </button>
                          <button
                            className="btn-action-search"
                            onClick={() => handleTabSelect("draft")}
                          >
                            <i className="fa fa-pencil-square-o" /> Drafts ({selectedPerformer.draftMail || 0})
                          </button>
                        </>
                      )}
                      <button
                        className="btn-action-search btn-primary-search"
                        onClick={() => handleModalShowHide(selectedPerformer, true)}
                      >
                        <i className="fa fa-envelope" /> {selectedPerformers.length > 1 ? `Send Bulk ${msgType === "text" ? "Text" : "Email"} (${selectedPerformers.length})` : `Send ${msgType === "text" ? "Text" : "Email"}`}
                      </button>
                      <button
                        className="btn-action-search btn-danger-search"
                        onClick={handleResetSelection}
                        title="Clear selection"
                      >
                        <i className="fa fa-times" />
                      </button>
                    </div>
                  </div>
                )}

                <div className="table-responsive mt-2 wf-table-scroll border">
                  <table className="table align-items-center table-flush table-striped wf-table">
                    <thead className="wf-thead">
                      <tr>
                        <th>ID</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Contact</th>
                        <th style={{ minWidth: "360px" }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isLoading ? (
                        Array.from({ length: pageSize > 5 ? 5 : pageSize }).map((_, i) => (
                          <tr key={`skel-${i}`} className="skeleton-row">
                            <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.07}s` }} /></td>
                            <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.06}s` }} /></td>
                            <td><span className="skeleton-cell sk-long" style={{ animationDelay: `${i * 0.08}s` }} /></td>
                            <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.07}s` }} /></td>
                            <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.05}s` }} /></td>
                          </tr>
                        ))
                      ) : candidates.length === 0 ? (
                        <tr>
                          <td colSpan={5} style={{ padding: 0 }}>
                            <div className="wf-empty-state" style={{ minHeight: "250px" }}>
                              <div className="wf-empty-icon">
                                <i className={dataType === "filter" ? "fa fa-search" : "fa fa-list-alt"} />
                              </div>
                              <p className="wf-empty-title">
                                {dataType === "filter" ? "No Matching Users" : "No Registered Users Found"}
                              </p>
                              <p className="wf-empty-desc">
                                {dataType === "filter"
                                  ? "Try adjusting or resetting the search filters to find users."
                                  : `There are no registered ${typeName.toLowerCase()} found in the system.`}
                              </p>
                              {dataType === "filter" && (
                                <button
                                  className="btn-action-search"
                                  onClick={handleFilterCancel}
                                  style={{ marginTop: 4 }}
                                >
                                  <i className="fa fa-refresh" aria-hidden="true" />
                                  Reset Filters
                                </button>
                              )}
                            </div>
                          </td>
                        </tr>
                      ) : (
                        candidates.map((item) => (
                          <tr
                            key={item.performerid}
                            className={`wf-table-row ${selectedEmail.some(x => x.key === item.performerid) ? "selected-row" : ""}`}
                            onClick={() => handleSelectPerformer(item)}
                            title={selectedEmail.some(x => x.key === item.performerid) ? `Click to deselect: ${item.performername}` : `Click to select: ${item.performername}`}
                          >
                            <td>
                              <span
                                className={`wf-id-cell${selectedEmail.some(x => x.key === item.performerid) ? " is-selected" : ""}`}
                              >
                                {selectedEmail.some(x => x.key === item.performerid) && (
                                  <i className="fa fa-check-circle text-primary" style={{ fontSize: "12px" }} />
                                )}
                                #{item.performerid}
                              </span>
                            </td>
                            <td>
                              <div className="wf-name-cell">
                                <span className="wf-name-avatar">{getInitials(item)}</span>
                                <div className="wf-name-meta">
                                  <span className="wf-name-main text-uppercase">
                                    {item.performername}&nbsp;{item.lastName}
                                  </span>
                                </div>
                              </div>
                            </td>
                            <td>
                              <span className="wf-data-line wf-email-line">
                                <i className="fa fa-envelope-o" aria-hidden="true" />
                                {item.performeremail || <span className="wf-empty-value">No Email</span>}
                              </span>
                            </td>
                            <td>
                              {item.contactNo ? (
                                <span className="wf-data-line">
                                  <i className="fa fa-phone" aria-hidden="true" />
                                  {getFormatedNumber(item.contactNo)}
                                </span>
                              ) : (
                                <span className="wf-empty-value">No Contact</span>
                              )}
                            </td>
                            <td onClick={(e) => e.stopPropagation()}>
                              <div style={{ display: "inline-flex", gap: "8px", alignItems: "center" }}>
                                <button
                                  type="button"
                                  className="btn-action-search btn-sent-action"
                                  onClick={() => handleShowHideMailHistory(item, "all")}
                                  title="View Sent History"
                                >
                                  <i className="fa fa-paper-plane" /> Sent ({item.allMail})
                                </button>
                                <button
                                  type="button"
                                  className="btn-action-search btn-draft-action"
                                  onClick={() => handleShowHideMailHistory(item, "draft")}
                                  title="View Draft Messages"
                                >
                                  <i className="fa fa-pencil-square-o" /> Drafts ({item.draftMail})
                                </button>
                                <button
                                  type="button"
                                  className="btn-action-search btn-primary-search"
                                  onClick={() => handleModalShowHide(item)}
                                  title="Compose and Send Message"
                                >
                                  <i className="fa fa-envelope" /> Send
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                  <Pagination
                    currentPage={currentPage}
                    pageSize={pageSize}
                    itemsCount={rowsCount}
                    onPageChange={handlePageChange}
                    startIndex={startIndex}
                    endIndex={endIndex}
                  />
                </div>
              </div>
            )}

            {selectedKey === "compose" && (
              <div className="wf-tab-panel pt-2">
                {selectedPerformerId > 0 ? (
                  <SendEmail
                    showHide={true}
                    handleModalShowHide={handleModalShowHide}
                    selectedObj={selectedPerformer}
                    selectedEmail={selectedEmail}
                    viewType="add"
                    isInline={true}
                    msgType={`${userType}${" "}${msgType}`}
                  />
                ) : (
                  <div className="wf-empty-state">
                    <div className="wf-empty-icon">
                      <i className="fa fa-envelope" />
                    </div>
                    <p className="wf-empty-title">No User Selected</p>
                    <p className="wf-empty-desc">Select a user from the registry table to compose and send a message.</p>
                    <button
                      className="btn-action-search"
                      onClick={() => handleTabSelect("home")}
                      style={{ marginTop: 4 }}
                    >
                      <i className="fa fa-arrow-left" /> Back to Registry
                    </button>
                  </div>
                )}
              </div>
            )}

            {selectedKey === "sent" && (
              <div className="wf-tab-panel pt-2">
                {selectedPerformerId > 0 ? (
                  <div className="awp-card mt-0 mb-3 border-0 shadow-none bg-transparent">
                    <div className="awp-form-header" style={{ borderRadius: "16px" }}>
                      <div className="awp-form-header-icon" style={{ color: "#0d9488", background: "rgba(13, 148, 136, 0.06)", borderColor: "rgba(13, 148, 136, 0.1)" }}>
                        <i className="fa fa-paper-plane" />
                      </div>
                      <div className="awp-form-header-text">
                        <p className="awp-form-header-title">Sent History</p>
                        <p className="awp-form-header-sub">
                          Viewing sent messages for {selectedPerformer?.performername} {selectedPerformer?.lastName}
                        </p>
                      </div>
                      <div className="awp-form-header-badge" style={{ color: "#0f766e", background: "#f0fdfa", borderColor: "#ccfbf1" }}>
                        <i className="fa fa-check-circle" /> {allEmailHistorySelector.filter(x => x.sendStatus === true).length} Sent
                      </div>
                    </div>
                  </div>
                ) : null}
                {selectedPerformerId > 0 ? (
                  <div className="table-responsive mt-2 wf-table-scroll border" style={{ borderRadius: "12px", border: "1px solid #e2e8f0" }}>
                    <table className="table align-items-center table-flush table-striped wf-table" style={{ margin: 0 }}>
                      <thead className="wf-thead">
                        <tr>
                          <th style={{ width: "80px", borderTop: "none" }}>S.No.</th>
                          <th style={{ width: "220px", borderTop: "none" }}>Sent Date Time</th>
                          <th style={{ width: "280px", borderTop: "none" }}>Subject</th>
                          <th style={{ borderTop: "none" }}>Body</th>
                          <th style={{ width: "280px", borderTop: "none" }}>Attachments</th>
                        </tr>
                      </thead>
                      <tbody>
                        {allEmailHistorySelector.filter(x => x.sendStatus === true).length === 0 ? (
                          <tr>
                            <td colSpan={5} className="text-center p-0">
                              <div className="wf-empty-state" style={{ minHeight: "220px", padding: "30px 24px", background: "transparent" }}>
                                <div className="wf-empty-icon" style={{ background: "rgba(13, 148, 136, 0.08)", color: "#0d9488", borderColor: "rgba(13, 148, 136, 0.12)" }}>
                                  <i className="fa fa-paper-plane-o" />
                                </div>
                                <p className="wf-empty-title">No Sent Messages</p>
                                <p className="wf-empty-desc" style={{ maxWidth: "400px" }}>
                                  You haven't sent any messages to {selectedPerformer?.performername} yet. Compose a new message to get started.
                                </p>
                              </div>
                            </td>
                          </tr>
                        ) : (
                          allEmailHistorySelector
                            .filter(x => x.sendStatus === true)
                            .map((item, idx) => (
                              <tr key={item.id} className="wf-table-row">
                                <td>
                                  <span className="wf-id-cell">#{idx + 1}</span>
                                </td>
                                <td>
                                  <span className="wf-data-line">
                                    <i className="fa fa-calendar-check-o text-primary" style={{ fontSize: "13px" }} />
                                    <span style={{ fontWeight: 600 }}>
                                      <Moment format="MMM Do YYYY, h:mm a">
                                        {item.sendDateTime || item.addedDateTime}
                                      </Moment>
                                    </span>
                                  </span>
                                </td>
                                <td>
                                  <span className="wf-name-main text-truncate d-block" style={{ maxWidth: "250px" }} title={item.subject}>
                                    {item.subject || <span className="text-muted font-italic" style={{ fontWeight: 400 }}>No Subject</span>}
                                  </span>
                                </td>
                                <td>
                                  <div className="text-muted" style={{ maxHeight: "44px", overflow: "hidden", textOverflow: "ellipsis", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", fontSize: "12.5px", lineHeight: "1.4" }} title={item.mailBody}>
                                    {item.mailBody || <span className="font-italic">Empty message</span>}
                                  </div>
                                </td>
                                <td>
                                  {item?.documents?.length > 0 ? (
                                    <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
                                      {item.documents.map((file, fIdx) => (
                                        <button
                                          key={fIdx}
                                          className="btn-action-search"
                                          style={{ padding: "4px 8px", fontSize: "11px", height: "auto", background: "#f8fafc" }}
                                          title="Download Attachment"
                                          onClick={() => handleDownloadFile(file)}
                                        >
                                          <i className="fa fa-paperclip text-primary" style={{ fontSize: "11px" }} />
                                          <span className="text-truncate" style={{ maxWidth: "120px" }}>{file.documentName}</span>
                                        </button>
                                      ))}
                                    </div>
                                  ) : (
                                    <span className="wf-empty-value">No Attachments</span>
                                  )}
                                </td>
                              </tr>
                            ))
                        )}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="wf-empty-state">
                    <div className="wf-empty-icon">
                      <i className="fa fa-envelope" />
                    </div>
                    <p className="wf-empty-title">No User Selected</p>
                    <p className="wf-empty-desc">Select a user from the registry table to view sent messages history.</p>
                    <button
                      className="btn-action-search"
                      onClick={() => handleTabSelect("home")}
                      style={{ marginTop: 4 }}
                    >
                      <i className="fa fa-arrow-left" /> Back to Registry
                    </button>
                  </div>
                )}
              </div>
            )}

            {selectedKey === "draft" && (
              <div className="wf-tab-panel pt-2">
                {selectedPerformerId > 0 ? (
                  <div className="awp-card mt-0 mb-3 border-0 shadow-none bg-transparent">
                    <div className="awp-form-header" style={{ borderRadius: "16px" }}>
                      <div className="awp-form-header-icon" style={{ color: "#7c3aed", background: "rgba(124, 58, 237, 0.06)", borderColor: "rgba(124, 58, 237, 0.1)" }}>
                        <i className="fa fa-pencil-square-o" />
                      </div>
                      <div className="awp-form-header-text">
                        <p className="awp-form-header-title">Draft Messages</p>
                        <p className="awp-form-header-sub">
                          Managing unsent drafts for {selectedPerformer?.performername} {selectedPerformer?.lastName}
                        </p>
                      </div>
                      <div className="awp-form-header-badge" style={{ color: "#6d28d9", background: "#f5f3ff", borderColor: "#ede9fe" }}>
                        <i className="fa fa-clock-o" /> {allEmailHistorySelector.filter(x => x.sendStatus !== true).length} Drafts
                      </div>
                    </div>
                  </div>
                ) : null}
                {selectedPerformerId > 0 ? (
                  <div className="table-responsive mt-2 wf-table-scroll border" style={{ borderRadius: "12px", border: "1px solid #e2e8f0" }}>
                    <table className="table align-items-center table-flush table-striped wf-table" style={{ margin: 0 }}>
                      <thead className="wf-thead">
                        <tr>
                          <th style={{ width: "80px", borderTop: "none" }}>S.No.</th>
                          <th style={{ width: "220px", borderTop: "none" }}>Created Date Time</th>
                          <th style={{ width: "280px", borderTop: "none" }}>Subject</th>
                          <th style={{ borderTop: "none" }}>Body</th>
                          <th style={{ width: "280px", borderTop: "none" }}>Attachments</th>
                          <th style={{ width: "250px", borderTop: "none" }}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {allEmailHistorySelector.filter(x => x.sendStatus !== true).length === 0 ? (
                          <tr>
                            <td colSpan={6} className="text-center p-0">
                              <div className="wf-empty-state" style={{ minHeight: "220px", padding: "30px 24px", background: "transparent" }}>
                                <div className="wf-empty-icon" style={{ background: "rgba(124, 58, 237, 0.08)", color: "#7c3aed", borderColor: "rgba(124, 58, 237, 0.12)" }}>
                                  <i className="fa fa-pencil-square-o" />
                                </div>
                                <p className="wf-empty-title">No Draft Messages</p>
                                <p className="wf-empty-desc" style={{ maxWidth: "400px" }}>
                                  There are no saved drafts for {selectedPerformer?.performername}.
                                </p>
                              </div>
                            </td>
                          </tr>
                        ) : (
                          allEmailHistorySelector
                            .filter(x => x.sendStatus !== true)
                            .map((item, idx) => (
                              <tr key={item.id} className="wf-table-row">
                                <td>
                                  <span className="wf-id-cell">#{idx + 1}</span>
                                </td>
                                <td>
                                  <span className="wf-data-line">
                                    <i className="fa fa-clock-o text-warning" style={{ fontSize: "13px" }} />
                                    <span style={{ fontWeight: 600 }}>
                                      <Moment format="MMM Do YYYY, h:mm a">
                                        {item.addedDateTime}
                                      </Moment>
                                    </span>
                                  </span>
                                </td>
                                <td>
                                  <span className="wf-name-main text-truncate d-block" style={{ maxWidth: "250px" }} title={item.subject}>
                                    {item.subject || <span className="text-muted font-italic" style={{ fontWeight: 400 }}>No Subject</span>}
                                  </span>
                                </td>
                                <td>
                                  <div className="text-muted" style={{ maxHeight: "44px", overflow: "hidden", textOverflow: "ellipsis", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", fontSize: "12.5px", lineHeight: "1.4" }} title={item.mailBody}>
                                    {item.mailBody || <span className="font-italic">Empty message</span>}
                                  </div>
                                </td>
                                <td>
                                  {item?.documents?.length > 0 ? (
                                    <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
                                      {item.documents.map((file, fIdx) => (
                                        <button
                                          key={fIdx}
                                          className="btn-action-search"
                                          style={{ padding: "4px 8px", fontSize: "11px", height: "auto", background: "#f8fafc" }}
                                          title="Download Attachment"
                                          onClick={() => handleDownloadFile(file)}
                                        >
                                          <i className="fa fa-paperclip text-primary" style={{ fontSize: "11px" }} />
                                          <span className="text-truncate" style={{ maxWidth: "120px" }}>{file.documentName}</span>
                                        </button>
                                      ))}
                                    </div>
                                  ) : (
                                    <span className="wf-empty-value">No Attachments</span>
                                  )}
                                </td>
                                <td onClick={(e) => e.stopPropagation()}>
                                  <div style={{ display: "flex", gap: "8px" }}>
                                    <button
                                      className="btn-action-search btn-sent-action"
                                      style={{ padding: "6px 10px", height: "auto" }}
                                      onClick={() => handleSendEmail(item)}
                                      title="Send Message"
                                    >
                                      <i className="fa fa-paper-plane" /> Send
                                    </button>
                                    <button
                                      className="btn-action-search"
                                      style={{ padding: "6px 10px", height: "auto" }}
                                      onClick={() => handleSendEmailShowHide(item)}
                                      title="Edit Draft"
                                    >
                                      <i className="fa fa-pencil" /> Edit
                                    </button>
                                    <button
                                      className="btn-action-search btn-danger-search"
                                      style={{ padding: "6px 10px", height: "auto" }}
                                      onClick={() => handleDeleteEmail(item)}
                                      title="Delete Draft"
                                    >
                                      <i className="fa fa-trash" /> Delete
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))
                        )}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="wf-empty-state">
                    <div className="wf-empty-icon">
                      <i className="fa fa-pencil-square-o" />
                    </div>
                    <p className="wf-empty-title">No User Selected</p>
                    <p className="wf-empty-desc">Select a user from the registry table to view draft messages.</p>
                    <button
                      className="btn-action-search"
                      onClick={() => handleTabSelect("home")}
                      style={{ marginTop: 4 }}
                    >
                      <i className="fa fa-arrow-left" /> Back to Registry
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>

          {showHide && (
            <SendEmail
              showHide={showHide}
              handleModalShowHide={handleModalShowHide}
              selectedObj={selectedObj}
              selectedEmail={selectedEmail}
              viewType="add"
              msgType={`${userType}${" "}${msgType}`}
            />
          )}

          {sendEmailShowHide && (
            <SendEmail
              showHide={sendEmailShowHide}
              handleModalShowHide={handleSendEmailShowHide}
              handleUpdateModalShowHide={handleUpdateModalShowHide}
              selectedObj={selectedPerformer}
              selectedEmail={selectedEmail}
              selectedMailObj={selectedMailObj}
              viewType="edit"
            />
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default UsersEmail;
